const config = {
    botUsername: "PromoMartBot",
    s3Url: "https://s3.promomartbot.ru/",
    supportLink: "https://t.me/atenSupport",
    offerLink: "https://s3.promomartbot.ru/public_of.docx",
    subsLimit: 15,
    specialOfferTimeout: 20 * 60,
    specialOffersPeriod: 1 * 24 * 60 * 60
};

export default config;
